import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'
import * as Displays from '@morningtrain/react-displays'
import * as UI from 'ui'
import OrderItemShouldContactStatus from 'widgets/smartviews/inventory/partials/OrderItemShouldContactStatus'

export default function InventoryDeliveryNoteSmartviewItem () {
  const inventoryItemId = useValue('id')

  const totalPath = ['globals.inventory.order_items', inventoryItemId, 'received_offset'].join('.')

  return (
    <WhenEnvValueMatches name={totalPath} matches={v => !!v && v !== 0}>
      <UI.WithSubtitle subtitle={<OrderItemShouldContactStatus />}>
        <UI.Text color='red' size='sm'>
          <Displays.Text name='name' />
        </UI.Text>
      </UI.WithSubtitle>
    </WhenEnvValueMatches>
  )
}
